/* ============================================================
   MY RARE AURA — PHASE 3 PRODUCT EXPERIENCE JS
   File: assets/aurelle-phase3.js
   Purpose: Complete-the-look Add to Bag, wishlist page rendering,
   wishlist counter, and safe cart refresh helpers.
   ============================================================ */

(function () {
  'use strict';

  function qs(selector, root) { return (root || document).querySelector(selector); }
  function qsa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem('aurelleWishlist') || '[]'); }
    catch (e) { return []; }
  }

  function writeWishlist(items) {
    localStorage.setItem('aurelleWishlist', JSON.stringify(items || []));
    window.dispatchEvent(new CustomEvent('aurelle:wishlist-updated'));
  }

  function updateWishlistCount() {
    var count = readWishlist().length;
    var targets = qsa('[data-aurelle-wishlist-count]');

    if (!targets.length) {
      var headerLinks = qsa('a[href*="wishlist"], a[href="/pages/wishlist"], a[href="/pages/aurelle-wishlist"]');
      headerLinks.forEach(function (link) {
        if (!link.querySelector('.aurelle-wishlist-count')) {
          var badge = document.createElement('span');
          badge.className = 'aurelle-wishlist-count';
          badge.setAttribute('data-aurelle-wishlist-count', '');
          link.appendChild(badge);
        }
      });
      targets = qsa('[data-aurelle-wishlist-count]');
    }

    targets.forEach(function (target) {
      target.textContent = count;
      target.hidden = count === 0;
    });
  }

  function renderWishlistPage() {
    var grid = qs('#AurelleWishlistGrid');
    var empty = qs('#AurelleWishlistEmpty');
    if (!grid) return;

    var items = readWishlist();
    grid.innerHTML = '';

    if (!items.length) {
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    items.forEach(function (item) {
      var card = document.createElement('article');
      card.className = 'aurelle-wishlist-card-wrap';
      card.innerHTML =
        '<a class="aurelle-wishlist-card" href="' + (item.url || '#') + '">' +
          '<img src="' + (item.image || '') + '" alt="' + String(item.title || 'Product').replace(/"/g, '&quot;') + '">' +
          '<p>My Rare Aura</p>' +
          '<strong>' + (item.title || 'Saved Product') + '</strong>' +
        '</a>' +
        '<button type="button" class="aurelle-wishlist-remove">Remove</button>';

      card.querySelector('.aurelle-wishlist-remove').addEventListener('click', function () {
        writeWishlist(readWishlist().filter(function (x) { return x.url !== item.url; }));
        renderWishlistPage();
      });

      grid.appendChild(card);
    });
  }

  function getCartDrawerSections(formData) {
    var cartDrawer = qs('cart-drawer');
    if (cartDrawer && cartDrawer.getSectionsToRender) {
      formData.append('sections', cartDrawer.getSectionsToRender().map(function (section) { return section.id; }));
      formData.append('sections_url', window.location.pathname);
    }
  }

  function openCart(data) {
    var cartDrawer = qs('cart-drawer');
    if (cartDrawer && cartDrawer.renderContents && data && data.sections) {
      cartDrawer.renderContents(data);
    } else if (cartDrawer && cartDrawer.open) {
      cartDrawer.open();
    }
  }

  function addVariant(id, quantity, button) {
    if (!id) return;

    var original = button ? button.textContent : '';
    var formData = new FormData();
    formData.append('id', id);
    formData.append('quantity', quantity || 1);
    getCartDrawerSections(formData);

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (err) { throw err; });
        return response.json();
      })
      .then(function (data) {
        if (button) button.textContent = 'Added ✓';
        openCart(data);
        setTimeout(function () {
          if (button) {
            button.disabled = false;
            button.textContent = original || 'Add';
          }
        }, 1100);
      })
      .catch(function (error) {
        console.warn('My Rare Aura add to cart error:', error);
        if (button) {
          button.disabled = false;
          button.textContent = 'Unavailable';
          setTimeout(function () { button.textContent = original || 'Add'; }, 1500);
        }
      });
  }

  function initCompleteLook() {
    qsa('.aurelle-complete-add').forEach(function (button) {
      button.addEventListener('click', function () {
        addVariant(button.dataset.variantId, 1, button);
      });
    });

    var addAll = qs('#AurelleAddCompleteLook');
    if (addAll) {
      addAll.addEventListener('click', function () {
        var buttons = qsa('.aurelle-complete-add:not(:disabled)');
        if (!buttons.length) return;

        addAll.disabled = true;
        addAll.textContent = 'Adding…';

        var items = buttons.map(function (button) {
          return { id: Number(button.dataset.variantId), quantity: 1 };
        }).filter(function (item) { return item.id; });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (err) { throw err; });
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function () {
            var cartDrawer = qs('cart-drawer');
            if (cartDrawer && cartDrawer.open) cartDrawer.open();
            addAll.textContent = 'Added ✓';
            setTimeout(function () {
              addAll.disabled = false;
              addAll.textContent = 'Add The Look';
            }, 1200);
          })
          .catch(function () {
            addAll.disabled = false;
            addAll.textContent = 'Unavailable';
            setTimeout(function () { addAll.textContent = 'Add The Look'; }, 1400);
          });
      });
    }
  }

  function enhanceRecentlyViewed() {
    var grid = qs('#AurelleRecentGrid');
    if (!grid) return;
    grid.setAttribute('role', 'list');
    qsa('.aurelle-recent-card', grid).forEach(function (card) { card.setAttribute('role', 'listitem'); });
  }

  function init() {
    updateWishlistCount();
    renderWishlistPage();
    initCompleteLook();
    enhanceRecentlyViewed();
  }

  window.addEventListener('aurelle:wishlist-updated', updateWishlistCount);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
